module.exports = __webpack_public_path__ + "static/media/SuiteS02.f3edbd04.jpg";